app.config(function ($stateProvider, $urlRouterProvider) {

    $stateProvider
        .state('root', {
            url: '/',
            controller: function($state) {
                // Redirect to dashboard from a valid state to prevent URL sync looping
                $state.go('dashboard.user.dashboard');
            }
        })
        .state('root-empty', {
            url: '',
            controller: function($state) {
                $state.go('dashboard.user.dashboard');
            }
        });

    // For any truly unmatched url, fall back safely to /
    $urlRouterProvider.otherwise("/");
});
